export default __webpack_public_path__ + "static/media/list-ol.84d72114.svg";